// third-party
import { Trans } from 'react-i18next';

// assets
import { IconMail } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconMail
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface EmailMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}

const email: EmailMenuProps = {
    id: 'mail',
    title: <Trans i18nKey="Mail" id="Mail" />,
    type: 'group',
    children: [
        {
            id: 'mail',
            title: <Trans i18nKey="Mail" id="Mail" />,
            type: 'item',
            url: '/mail',
            icon: icons.IconMail,
            breadcrumbs: false
        },
    ]
};

export default email;
